import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
// import shipment from "../../../dummy-data/shipment_p.json";
const Cards = ({
  pageClass,
  lang,
  dataCard1,
  switcher_1,
  activeCard,
  setActiveCard,
  fetchTableData }) => {

  const dataTranslate = require(`../../../translate/${lang === "AR" ? "arabic" : "english"
    }/data.json`);

  const [singleSection, setSingleSection] = useState(false);
  useEffect(() => {
    if (!dataCard1) {
      setSingleSection(() => true);
    } else {
      setSingleSection(() => false);
    }
  }, []);
  return (
    <div
      className={`${pageClass}-cards w-100 d-flex flex-row ${singleSection
        ? "align-items-center justify-content-center"
        : "align-items-start justify-content-between"
        }`}
    >
      <div className={`${pageClass}-cards-section1`}>
        <Container
          className={`d-flex align-items-center justify-content-${singleSection ? "center" : "start"
            }`}
        >
          <Row className="gap-3">
            {dataCard1.map((item, index) => {
              let { key, title } = switcher_1(item, dataTranslate);
              return (
                <Col
                  key={index}
                  onClick={() => {
                    setActiveCard(key);
                    fetchTableData(key);
                  }}
                >
                  <Card className={`${pageClass}-cards-section1-card`}>
                    <Card.Body
                      className={
                        activeCard === key
                          ? "active-card d-flex flex-column align-items-center text-center"
                          : "d-flex flex-column align-items-center text-center"
                      }>
                      <Card.Title>{title}</Card.Title>
                      <Card.Text>
                        <h1>{item[key]}</h1>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Container>
      </div>
      {/* <div className="shipment_p-cards-section2">
        <Container className="d-flex align-items-center justify-content-end">
          <Row className="gap-3">
            {shipment.cards2.map((item, index) => {
              return (
                <Col key={index}>
                  <Card className="shipment_p-cards-section1-card">
                    <Card.Body className="d-flex flex-column align-items-center text-center">
                      <Card.Title>{item.title}</Card.Title>
                      <Card.Text>
                        <h1> {item.count}</h1>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Container>
      </div> */}
    </div>
  );
};

export default Cards;
